import { AuditColumnModel, PlantModel } from "src/app/model";

export enum EntityValue {
  VEHICLE = 1,
  ASSET,
  PEOPLE,
  DTC,
  ALERTPROFILE
}

export enum EntityPage {
  VEHICLES = "vehicles",
  ASSETS = "assets",
  PEOPLE = "people",
  DTC = 'dtc',
  ALERTPROFILE = 'alertProfile'
}

export enum EntityTagStatus {
  TAG,
  UNTAG
}

export enum EntityCardView {
  GENERIC = 'generic',
  MONOTAINER_TRACK = 'monotainer-track',
  ASSET_TRACK = 'asset-track',
  VALIDOPS_VEHICLE_TRACK = 'validops-vehicle-track'
}

export type EntityType = EntityValue.ASSET | EntityValue.PEOPLE | EntityValue.VEHICLE | EntityValue.DTC | EntityValue.ALERTPROFILE;

export type EntityPageType = EntityPage.ASSETS | EntityPage.PEOPLE | EntityPage.VEHICLES | EntityPage.DTC | EntityPage.ALERTPROFILE;

export type EntityTagStatusType = EntityTagStatus.TAG | EntityTagStatus.UNTAG;

export type EntityCardViewType = EntityCardView.ASSET_TRACK | EntityCardView.GENERIC | EntityCardView.MONOTAINER_TRACK | EntityCardView.VALIDOPS_VEHICLE_TRACK;

export interface EntityModel extends Pick<AuditColumnModel, "_id"> {
  name: string;
  uniqueId: string;
  type: EntityType;
  status: boolean;
  category: string;
  location?: string;
  image?: string;
  primaryDetails: {
    [s: string]: any;
  };
  secondaryDetails: {
    [s: string]: any;
  };
  certificateDetails: {
    [s: string]: any;
  };
  assetDetails?: {
    zones: {
      id: string;
      name: string;
      destination: string;
    }[];
    name: string;
    state: string;
    taggedBy: string;
    taggedOn: string;
    tagId: string;
    destination: string;
  };
  sites: Pick<PlantModel, "_id" | "name">;
  primaryDetailsList?: string[];
  iconDetails?: EntityAlertModel;
  aggrDetails?: AggrListModel;
  defaultImage?: string;
  operationalStatus: string;
  coordinates: {lat: number, long: number};
  activeDtcCasesCount?: number;
}

export interface AggrListModel {
  totalEnginehours: string,
  createdTime: string,
  totalDistance: string,
  uniqueId: string,
  trimmedTotalDistance: number,
  totalEnginehoursTrimmed: number
}

export interface EntityTileModel {
  data: EntityModel[];
  pageType: 'people' | 'assets' | 'vehicles';
  entityType: EntityType;
}

export interface EntityAlertIconModel {
  alert: string;
  attributeValue: string;
  imgUrl: string;
}

export interface EntityAlertModel extends Pick<AuditColumnModel, "_id"> {
  alerts: EntityAlertIconModel[],
  alertsCount: number;
}

export interface EntityIconDataModel {
  category: string;
  imgUrl: string;
  altName: string;
}

export interface EntityIconModel {
  entityType: EntityType;
  headerIconList: EntityIconDataModel[];
  footerIconList: EntityIconDataModel[];
  bodyIconList: EntityIconDataModel[];
}

export interface EntityTrackPayloadModel {
  siteId: string;
  from: string;
  to: string;
  entityId: string;
  entityIds: string[];
  entityCategory: string;
  isActive: boolean;
  searchKey?:string;
  limit?: number
}

export interface EntityTrackAttributeModel {
  windowAvg: string;
  attributeValue: string;
  attributeName: string;
  RateDiff: string;
  operation: string;
  RawValue: string;
}

export interface EntityTrackModel {
  entityId: string;
  entityName: string;
  gatewayId: string;
  siteId: string;
  siteName: string;
  sourceTimestamp: string;
  entityCategory: string;
  attributes: EntityTrackAttributeModel[];
  status?: string;
}

export interface EntityTrackModeModel {
  original: EntityTrackModel[];
}

export interface EntityAlertsCountPayloadModel {
  siteId: string;
  from: string;
  to: string;
  entityId: string;
  entityCategory: string;
  status: boolean;
}
